import type { RootState } from "types/redux";

export const getIsPresentationDownloading = (state: RootState) => state.domains.topic.isPresentationDownloading;
